__turbopack_context__.v({
  "button": "Header-module__vcZAwq__button",
  "header": "Header-module__vcZAwq__header",
  "line": "Header-module__vcZAwq__line",
  "main": "Header-module__vcZAwq__main",
  "menubutton": "Header-module__vcZAwq__menubutton",
  "motto": "Header-module__vcZAwq__motto",
  "nav": "Header-module__vcZAwq__nav",
  "right": "Header-module__vcZAwq__right",
});
